const imageCarousels = [
  {
    page: '5',
    style: 'pagination',
    arrowColor: 'dark',
    left: '34%',
    bottom: '5%',
    width: '32%',
    aspectRatio: '1.5',
    parallax:0,
    images: [
      { src: './carousel-images/carousel-2-a.jpg', alt: 'The La Bola Negra cast and crew gathered around a celebration' },
      { src: './carousel-images/carousel-2-b.jpg', alt: 'Black billiard balls on a green table' },
    ],
    mobile: {
      left: '14%',
      top: '30%',
      width: '72%',
    },
  },
  {
    page: '9',
    style: 'stack',
    arrowColor: 'light',
    right: '-20%',
    top: '20%',
    width: '55%',
    aspectRatio: '0.75',
    images: [
      { src: './carousel-images/9-1.jpg', alt: 'Four light-toned La Bola Negra poster designs featuring a black sphere and handwritten lettering.' },
      { src: './carousel-images/9-2.jpg', alt: 'Four darker La Bola Negra poster designs showing a black sphere against contrasting backgrounds.' },
      { src: './carousel-images/9-3.jpg', alt: 'Cast and crew gather around a table beneath a production tent.' },
      { src: './carousel-images/9-4.jpg', alt: 'A pink film clapperboard for La bola negra, lit in red.' },
      { src: './carousel-images/9-5.jpg', alt: 'Crew film an outdoor scene as costumed performers and extras gather nearby.' },
      { src: './carousel-images/9-6.jpg', alt: 'A collage documents an actor trying on a brown vest, with close-ups of its construction and fabric.' },
      { src: './carousel-images/9-7.jpg', alt: 'Costume crew fit a garment on a mannequin and work at a sewing table.' },
      { src: './carousel-images/9-8.jpg', alt: 'Black-and-white film set with actors on the ground and a camera crew filming beside them.' },
      { src: './carousel-images/9-9.jpg', alt: 'Three crew members work around a table in a workshop while a dog rests on the floor.' },
      { src: './carousel-images/9-10.jpg', alt: 'A light-colored dog sits atop a military tank outdoors.' },
      { src: './carousel-images/9-11.jpg', alt: 'A woman stands on an overturned vehicle in a town square at night.' },
      { src: './carousel-images/9-12.jpg', alt: 'A seated woman holds a telephone receiver beside a stone wall.' },
      { src: './carousel-images/9-13.jpg', alt: 'A historic field cannon is secured on a flatbed truck for transport.' },
      { src: './carousel-images/9-14.jpg', alt: 'A smiling man and woman take a selfie on a stone-built film set.' },
      { src: './carousel-images/9-15.jpg', alt: 'A seated musician holds a brass trumpet between his knees.' },
    ],
    mobile: {
      left: '8%',
      top: '30%',
      width: '84%',
    },
  },
  
];

export default imageCarousels;